import { render, staticRenderFns } from "./CrmWeeklySales.vue?vue&type=template&id=61927847&"
import script from "./CrmWeeklySales.vue?vue&type=script&lang=js&"
export * from "./CrmWeeklySales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports